import styled from 'styled-components';

export const CalculationErrorContainer = styled.div`
  padding-bottom: 0;
`;

export const CalculationDesc = styled.p`
  padding-bottom: 14px !important;
`;

export const DueDateContent = styled.div`
  padding: 0px 6em;
  @media (max-width: 720px) {
    padding: 0px 1em;
  }

  p {
    padding-bottom: 10px;
    color: rgb(0 0 0 / 80%);
    font-size: 16px;
  }

  div p {
    &:nth-last-child(1) {
      padding-bottom: 20px;
    }
  }

  h2 {
    padding-bottom: 8px;
    font-size: 24px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
  }

  h3 {
    padding-bottom: 8px;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
  }

  ul {
    list-style: auto;
    margin: 0;
    padding: 0;
    margin-left: 35px;
  }

  li {
    padding-bottom: 5px;
    color: rgb(0 0 0 / 80%);
    font-size: 16px;
  }

  &.showLinks {
    a {
      text-decoration: underline;
      color: rgb(0, 0, 238);
    }

    a:visited {
      text-decoration: underline;
      color: rgb(85, 26, 139);
    }
  }

  &.no_highlight {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;

export const FlexBox = styled.div`
  display: flex;
  align-items: center;

  b {
    font-size: 14px;
    color: #00000099;
  }
`;

export const ListDesc = styled.p`
  margin-left: 17px;
`;
